import styled from 'styled-components';

export const Title = styled.h2`
  margin: 0;
`;

export const Form = styled.form`
  height: calc(100% - 130px);
`;

export const Body = styled.div`
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const BodyContainer = styled.div`
  display: flex;
  padding: 20px;
`;

export const Label = styled.label`
  display: flex;
  margin-bottom: 20px;
  font-size: 17px;
  font-weight: bold;
`;

export const ControlsContainer = styled.div`
  flex: 0.6;
  background: white;
  margin-right: 15px;
  padding: 15px;
  border-radius: 5px;
`;
export const ViewContainer = styled.div`
  flex: 1;
  background: white;
  padding: 10px;
  border-radius: 5px;
`;
